import { cardItems } from '@/mocks/home';

export default function SectionCards() {
  return (
    <section id="cards" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6">
          <i className="ri-gallery-line text-primary-500 mr-2"></i>
          精选推荐
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cardItems.slice(0, 4).map((item) => (
            <article
              key={item.title}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 cursor-pointer hover:border-primary-200"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4">
          {cardItems.slice(4, 7).map((item) => (
            <article
              key={item.title}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 cursor-pointer hover:border-primary-200"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}